const offlineEventData = {

  "you-we-can-campaign": {
    badge: "OFFLINE EVENT",
    title: "YouWeCan Campus Awareness Campaign",
    description:
      "A nationwide cancer awareness initiative executed across universities to educate and engage youth on early detection.",

    location: "Pan India",
    attendees: "10,000+ Students",
    date: "Multi-City Campaign",

    heroVideo: "/offline-events/youwecan-video.mp4",

    stats: [
      { number: "26+", label: "Universities Covered" },
      { number: "10,000+", label: "Students Engaged" },
      { number: "Pan India", label: "Campaign Reach" },
      { number: "High Impact", label: "Youth Engagement" }
    ],

    eventDetails: {
      type: "University Awareness Campaign",
      audience: "College Students",
      execution: "Multi-City Activation",
      organizer: "WeCanServe",
      client: "Zuvius Lifesciences"
    },

    gallery: [
      "/offline-events/youwecanzuviuslifesciences1.jpg",
      "/offline-events/youwecanzuviuslifesciences2.jpg",
      "/offline-events/youwecanzuviuslifesciences3.jpg",
      "/offline-events/youwecanzuviuslifesciences4.jpg",
      "/offline-events/youwecanzuviuslifesciences5.jpg",
      "/offline-events/youwecanzuviuslifesciences6.jpg",
      "/offline-events/youwecanzuviuslifesciences7.jpg",
      "/offline-events/youwecanzuviuslifesciences8.jpg",
      "/offline-events/youwecanzuviuslifesciences9.jpg",
      "/offline-events/youwecanzuviuslifesciences10.jpg",
      "/offline-events/youwecanzuviuslifesciences11.jpg",
      "/offline-events/youwecanzuviuslifesciences12.jpg",
      "/offline-events/youwecanzuviuslifesciences13.jpg",
      "/offline-events/youwecanzuviuslifesciences14.jpg",
      "/offline-events/youwecanzuviuslifesciences15.jpg",
      "/offline-events/youwecanzuviuslifesciences16.jpg",
      "/offline-events/youwecanzuviuslifesciences17.jpg",
      "/offline-events/youwecanzuviuslifesciences18.jpg",
      "/offline-events/youwecanzuviuslifesciences19.jpg",
      "/offline-events/youwecanzuviuslifesciences20.jpg",
      "/offline-events/youwecanzuviuslifesciences21.jpg",
      "/offline-events/youwecanzuviuslifesciences22.jpg",
      "/offline-events/youwecanzuviuslifesciences23.jpg",
      "/offline-events/youwecanzuviuslifesciences24.jpg",
      "/offline-events/youwecanzuviuslifesciences25.jpg",
      "/offline-events/youwecanzuviuslifesciences26.jpg",
      "/offline-events/youwecanzuviuslifesciences27.jpg",
      "/offline-events/youwecanzuviuslifesciences28.jpg",
      "/offline-events/youwecanzuviuslifesciences29.jpg",
      "/offline-events/youwecanzuviuslifesciences30.jpg",
      "/offline-events/youwecanzuviuslifesciences31.jpg",
      "/offline-events/youwecanzuviuslifesciences32.jpg",
      "/offline-events/youwecanzuviuslifesciences33.jpg",
      "/offline-events/youwecanzuviuslifesciences34.jpg",
      "/offline-events/youwecanzuviuslifesciences35.jpg",
      "/offline-events/youwecanzuviuslifesciences36.jpg",
      "/offline-events/youwecanzuviuslifesciences37.jpg",
      "/offline-events/youwecanzuviuslifesciences38.jpg",
      "/offline-events/youwecanzuviuslifesciences39.jpg",
      "/offline-events/youwecanzuviuslifesciences40.jpg",
      "/offline-events/youwecanzuviuslifesciences41.jpg",
      "/offline-events/youwecanzuviuslifesciences42.jpg",
      "/offline-events/youwecanzuviuslifesciences43.jpg",
      "/offline-events/youwecanzuviuslifesciences44.jpg",
      "/offline-events/youwecanzuviuslifesciences45.jpg"
    ]
  },

  "pink-street-campaign": {
    badge: "OFFLINE EVENT",
    title: "Pink Street Awareness Campaign",
    description:
      "A large-scale experiential campaign creating a powerful visual symbol of unity through a massive pink ribbon installation.",

    location: "Karad",
    attendees: "25,000+",
    date: "Awareness Drive",

    heroVideo: "/offline-events/pinkstreetwebsitevideo.mp4",

    stats: [
      { number: "6,878 sq.ft.", label: "Ribbon Size" },
      { number: "25,000+", label: "People Reached" },
      { number: "1,528", label: "Participants" },
      { number: "Limca Record", label: "Recognition" }
    ],

    eventDetails: {
      type: "Experiential Campaign",
      audience: "Students & Public",
      execution: "Mass Participation Activity",
      organizer: "WeCanServe",
      client: "KIMS"
    },

    gallery: [
      "/offline-events/pinkstreetzuviuslifesciences1.jpg",
      "/offline-events/pinkstreetzuviuslifesciences2.jpg",
      "/offline-events/pinkstreetzuviuslifesciences3.jpg",
      "/offline-events/pinkstreetzuviuslifesciences4.jpg",
      "/offline-events/pinkstreetzuviuslifesciences5.jpg",
      "/offline-events/pinkstreetzuviuslifesciences6.jpg",
      "/offline-events/pinkstreetzuviuslifesciences7.jpg",
      "/offline-events/pinkstreetzuviuslifesciences8.jpg",
      "/offline-events/pinkstreetzuviuslifesciences9.jpg",
      "/offline-events/pinkstreetzuviuslifesciences10.jpg",
      "/offline-events/pinkstreetzuviuslifesciences11.jpg",
      "/offline-events/pinkstreetzuviuslifesciences12.jpg",
      "/offline-events/pinkstreetzuviuslifesciences13.jpg",
      "/offline-events/pinkstreetzuviuslifesciences14.jpg"    ]
  },

  "men-for-pink": {
    badge: "OFFLINE EVENT",
    title: "Men For Pink Initiative",
    description:
      "An awareness initiative focused on involving men in the conversation around breast cancer and breaking social stigma.",

    location: "India",
    attendees: "Community Driven",
    date: "Awareness Campaign",

    heroVideo: "/offline-events/menforpinkwebsitevideo.mp4",

    stats: [
      { number: "High Reach", label: "Community Engagement" },
      { number: "Interactive", label: "Seminars Conducted" },
      { number: "#MenForPink", label: "Campaign Movement" },
      { number: "Expanded", label: "Audience Reach" }
    ],

    eventDetails: {
      type: "Awareness Initiative",
      audience: "Male Community Leaders",
      execution: "Seminars & Engagement",
      organizer: "WeCanServe",
      client: "Healthcare Initiative"
    },

    gallery: [
      "/offline-events/menforpinkzuviuslifesciences1.jpg",
      "/offline-events/menforpinkzuviuslifesciences2.jpg",
      "/offline-events/menforpinkzuviuslifesciences3.jpg",
      "/offline-events/menforpinkzuviuslifesciences4.jpg",
      "/offline-events/menforpinkzuviuslifesciences5.jpg",
      "/offline-events/menforpinkzuviuslifesciences6.jpg",
      "/offline-events/menforpinkzuviuslifesciences7.jpg",
      "/offline-events/menforpinkzuviuslifesciences8.jpg",
      "/offline-events/menforpinkzuviuslifesciences9.jpg",
      "/offline-events/menforpinkzuviuslifesciences10.jpg",
      "/offline-events/menforpinkzuviuslifesciences11.jpg",
      "/offline-events/menforpinkzuviuslifesciences12.jpg",
      "/offline-events/menforpinkzuviuslifesciences13.jpg",
      "/offline-events/menforpinkzuviuslifesciences14.jpg",
      "/offline-events/menforpinkzuviuslifesciences15.jpg",
      "/offline-events/menforpinkzuviuslifesciences16.jpg"
    ]
  },

  "walk-for-cancer-care": {
    badge: "OFFLINE EVENT",
    title: "Walk for Cancer Care",
    description:
      "A community-driven awareness walk bringing together families and individuals to promote early detection and cancer care awareness.",

    location: "Dombivli",
    attendees: "Public Participation",
    date: "Community Walk",

    heroVideo: "/offline-events/WalkForCancerCareZuviusLifesciences.mp4",

    stats: [
      { number: "Strong", label: "Community Participation" },
      { number: "Wide", label: "Public Awareness" },
      { number: "Engaged", label: "Local Families" },
      { number: "Impactful", label: "Awareness Movement" }
    ],

    eventDetails: {
      type: "Awareness Walk",
      audience: "General Public",
      execution: "Community Event",
      organizer: "WeCanServe",
      client: "Healthcare Initiative"
    },

    gallery: [
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent1.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent2.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent3.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent4.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent5.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent6.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent7.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent8.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent9.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent10.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent11.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent12.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent13.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent14.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent15.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent16.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent17.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent18.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent19.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent20.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent21.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent22.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent23.jpg",
      "/offline-events/WalkForCancerCareZuviusLifesciencesEvent24.jpg"
    ]
  }

};

export default offlineEventData;